import { ExtendedAvatar, AvatarPropsExtended } from "../ExtendedAvatar";
export const Avatar = ExtendedAvatar;
export interface AvatarProps extends AvatarPropsExtended {}
